export const CONTACT_EMAIL = 'petteraminoff@gmail.com';
export const CONTACT_PHONE = '0500-424258';
export const CONTACT_PHONE_HREF = 'tel:+358500424258';
export const CONTACT_PERSON = 'Petter Aminoff';
export const BUSINESS_ID = '1131109-0';

export const ADDRESS = {
  street: 'Ruhalantie 444',
  postal: '34600 Ruovesi',
  full: 'Ruhalantie 444, 34600 Ruovesi',
};

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/profile.php?id=61575547291281',
  // instagram: add company Instagram URL here when it exists
};

export const DELIVERY_AREAS = [
  'Ruovesi',
  'Tampere',
  'Nokia',
  'Ylöjärvi',
  'Mänttä-Vilppula',
  'Virrat',
  'Orivesi',
  'Kangasala',
  'Sastamala',
  'Ikaalinen',
];
